export const PASSWORD_RESET_REQUEST_FORM_SUBMITTED = "PASSWORD_RESET_REQUEST_FORM_SUBMITTED"
export const passwordResetReqeustFormSubmitted = (email: string) => ({
    type: PASSWORD_RESET_REQUEST_FORM_SUBMITTED,
    payload: {
        email: email,
    },
})

export const PASSWORD_RESET_REQUEST_SUCCESS = "PASSWORD_RESET_REQUEST_SUCCESS"
export const passwordResetRequestSuccess = () => ({
    type: PASSWORD_RESET_REQUEST_SUCCESS,
})

export const PASSWORD_RESET_REQUEST_FAILURE = "PASSWORD_RESET_REQUEST_FAILURE"
export const passwordResetRequestFailure = (error: any) => ({
    type: PASSWORD_RESET_REQUEST_FAILURE,
    payload: {
        error: error,
    },
})
